import { Mood } from "@mui/icons-material";
import { IconButton, InputAdornment, Popover, TextField } from "@mui/material";
import Picker from "emoji-picker-react";
import { useState } from "react";

const EmojiTextField = (props) => {
    const { emoji, onEmojiInsert, ...rest } = props;
    const [popoverAnchor, setPopoverAnchor] = useState(null);
    const [selectionEnd, setSelectionEnd] = useState(null);

    const handleEmojiInsert = (emoji) => {
        let value = rest.value || '';
        if (selectionEnd !== null) {
            value = value.substring(0, selectionEnd) + emoji.emoji + value.substring(selectionEnd, value.length);
        } else {
            value = `${value}${emoji.emoji}`;
        }
        if (onEmojiInsert) {
            onEmojiInsert(value);
        }
        handleEmojiClose();
    };

    const handleEmojiOpen = (e, t) => {
        setPopoverAnchor(e.currentTarget);
    };

    const handleEmojiClose = () => {
        setPopoverAnchor(null);
    };

    return (
        <>
            <Popover keepMounted={false} onClose={handleEmojiClose} anchorEl={popoverAnchor} open={!!popoverAnchor}>
                <Picker
                    pickerStyle={{ width: '100%' }}
                    onEmojiClick={handleEmojiInsert}
                    disableAutoFocus
                    groupNames={{ smileys_people: 'PEOPLE' }}
                    emojiStyle="native"
                    native
                />
            </Popover>
            <TextField
                onSelect={(e) => {
                    if (e.target.selectionStart !== undefined) {
                        setSelectionEnd(e.target.selectionStart);
                    }
                }}
                InputProps={emoji ? {
                    endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            size="small"
                            disabled={rest.disabled}
                            onClick={(e) => handleEmojiOpen(e)}
                        >
                            <Mood />
                        </IconButton>
                    </InputAdornment>
                    )
                } : {}}
                {...rest}
            />
        </>
    );
};

export default EmojiTextField;